module.exports = __webpack_public_path__ + "media/images/niq-search-166b6378eae976d4a3be0f872d3544c6.svg";